import { ApiConfig } from "config/config";

export interface IUserAuthenticationInfo {
	isAuthenticated(): boolean;
	getAccessToken(): string;
	getAccessTokenExpiry(): number;
	getUserAuth0Id(): string;
}

// Ensure every request to API includes access token and auth0id
export const ConfigureFetchAuthentication = (axios, authentication: IUserAuthenticationInfo) => {
	axios.interceptors.request.use(
		config => {
			if (config.url && config.url.startsWith(ApiConfig.url)) {
				if (authentication.isAuthenticated()) {
					const accessToken = authentication.getAccessToken();
					const userAuth0Id = authentication.getUserAuth0Id();
					const headers = {
						Authorization: `Bearer ${accessToken}`,
						UserAuth0Id: `${userAuth0Id}`
					};

					config.headers = { ...config.headers, ...headers };
				}
			}
			return config;
		},
		error => Promise.reject(error)
	);
	console.debug('axios authentication configured');
}



// WEBPACK FOOTER //
// ./src/api/AxiosSetup.ts